import { isNil } from 'lodash/fp'
import { FC, ReactNode } from 'react'
import { colors, fonts, media, styles } from 'shared/lib'
import Head from 'next/head'
import styled from 'styled-components'
import Image from 'shared/components/Image'

type StaticPageProps = Partial<{
  title: string
  Paragraph: FC
  heroImagePath?: string
  children: ReactNode
  qaAttr?: string
}>
const StaticPage = (props: StaticPageProps) => {
  const { title, heroImagePath, children, qaAttr } = props
  const hasHeroImage = !isNil(heroImagePath)
  return (
    <>
      <Head>
        <title>{title}</title> 
      </Head>
      <Wrapper>
        <Article hasHeroImage={hasHeroImage}>
          {heroImagePath ? (
            <>
              <HeroImage
                src={heroImagePath}
                alt={title}
                width={500}
                height={250}
              />
              <ContentWrapper>
                <Header data-qa={`${qaAttr}PageTitle`} hasHeroImage>
                  {title}
                </Header>
                {children}
              </ContentWrapper>
            </>
          ) : (
            <>
              <Header data-qa={`${qaAttr}PageTitle`}>{title}</Header>
              {children}
            </>
          )}
        </Article>
      </Wrapper>
    </>
  )
}

export const HeroImage = styled(Image)`
  width: 100%;
  ${media.large`
    height: 250px;
    width: auto;
    order: 1;
  `}
`

const ImageContainer = styled.div`
  position: relative;
  height: 175px;
  width: 100%;
  ${media.large`
    height: 250px;
  `}
`
const Wrapper = styled.div`
  background-color: ${colors.FC2_WHITE};
  height: 100%;
  padding: ${styles.mobilePageLayoutPadding};
  ${media.large`
    display: flex;
    align-items: center;
    padding: 80px 150px 100px;
  `}
`
const Paragraph = styled.p`
  ${fonts.BODY_TEXT}
  line-height: 16px;
` 
const Article = styled.article<{ hasHeroImage: boolean }>`
  width: 100%;
  ${media.large`
    display: flex;
    flex-direction: ${({ hasHeroImage }) => (hasHeroImage ? 'row' : 'column')};
    order: 0;
  `}
`
export const Header = styled.h1<{ hasHeroImage?: boolean }>`
  ${fonts.HEADER_1}
  ${({ hasHeroImage }) => !hasHeroImage && 'margin-top: 0;'}
`

export const ContentWrapper = styled.div`
  ${media.large`
    margin-right: 100px;
  `}
`

StaticPage.Paragraph = ({ children }) => <Paragraph>{children}</Paragraph>
export default StaticPage
